import actions from "./actions";

const {
    FETCH_PROVIDENT_FUND_EMPLOYEES,
} = actions;

const initState = {
    providentFundEmployees: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    providentFundEmployee: { _id: null }
};

const ProvidentFundEmployeeReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_PROVIDENT_FUND_EMPLOYEES:
            return {
                ...state,
                providentFundEmployees: data
            };

        default:
            return state;
    }
};

export default ProvidentFundEmployeeReducer;

